import { render, staticRenderFns } from "./ScrollHintArrowsHoriz.vue?vue&type=template&id=7c7323c8&scoped=true"
import script from "./ScrollHintArrowsHoriz.vue?vue&type=script&lang=ts"
export * from "./ScrollHintArrowsHoriz.vue?vue&type=script&lang=ts"
import style0 from "./ScrollHintArrowsHoriz.vue?vue&type=style&index=0&id=7c7323c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7323c8",
  null
  
)

export default component.exports